import {
    Component,
    ElementRef,
    EventEmitter,
    forwardRef,
    Input,
    OnChanges,
    Output,
    ViewChild
} from '@angular/core';

import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MODAL_EDITOR_TOKEN, ModalEditorBase } from '../../../classes/modal-editor-base';
import { EditorToken } from '../../../models/editor-token';
import { InputFieldType } from '../../../types/input-field.type';


@Component({
    selector: 'ft-textarea-editor',
    templateUrl: './textarea-editor.component.html',
    styleUrls: ['./textarea-editor.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => TextareaEditorComponent)
        },
        {
            provide: MODAL_EDITOR_TOKEN,
            useExisting: TextareaEditorComponent
        }
    ],
    standalone: false
})
export class TextareaEditorComponent extends ModalEditorBase implements OnChanges {
    @ViewChild('textareaElement', { static: false }) textareaElement: ElementRef;
    @Input() maxlength: number;
    @Input() minlength: number;
    @Input() pattern: string;
    @Input() patternValidationText: string;
    @Input() type: InputFieldType = 'text';
    @Input() tokens: EditorToken[] = [];
    @Input() secondButton: string = null;
    @Output() action = new EventEmitter<any>();
    selectedToken: EditorToken = null;


    constructor() {
        super();
    }

    ngOnChanges() {
        if (this.type === 'url') {
            this.patternValidationText = 'Value is not valid url.';
            this.pattern = 'https?://.+';
        }
    }

    onTokenSelected(token) {
        const selectionStart = this.textareaElement.nativeElement.selectionStart;
        this.value = this.value ? this.value.slice(0, selectionStart) + `${token}` + this.value.slice(selectionStart) : token;

        setTimeout(() => {
            this.selectedToken = null;
            this.textareaElement.nativeElement.focus();
        });
    }
}


